import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { ApiService } from './api.service';

@Injectable()
export class ImportDataService extends ApiService {
  constructor(private http: Http) {
    super('api/import/', http);
  }
  importFile(type: String, ship_cfr: String, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('excel_type', String(type));
    formData.append('ship_id', String(ship_cfr));
    formData.append('file', file);

    const url = `${this.apiUrl + this.endpointUrl}import_csv_file/`;
    return this.http
      .post(url, formData, { headers: this.getHeaders(false) })
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/import-data.service.ts